module.exports = __webpack_public_path__ + "img/mobile-phone.ed7a9a76.png";